import { IconAppPolls, IconBtnGo } from 'app/components/_Icons'
import Button from 'app/common/ui/Button'
import { APP_POLLS } from 'app/common/constants/services'
import { withTranslation, Trans } from 'react-i18next'
import PlainToggle from 'app/common/ui-next/plain-toggle'

import styles from './AppPolls.scss'


// const propTypes = {
//   type: React.PropTypes.string.isRequired,
//   name: React.PropTypes.string.isRequired,
//   service: React.PropTypes.string.isRequired,
//   isChosen: React.PropTypes.bool.isRequired,
//   onSwitchChosen: React.PropTypes.func.isRequired,
//   activeCount: React.PropTypes.number.isRequired,
//   newCount: React.PropTypes.number.isRequired,
//   appLink: React.PropTypes.string.isRequired,
// };

const AppPolls = ({ type, name, isChosen, activeCount, newCount, appLink, onSwitchChosen, t }: any) => (
  <div className={styles.root}>

    <div className={styles.header}>
      <IconAppPolls className={styles.icon} />
      <div>
        <div className={styles.type}>{type}</div>
        <h2 className={styles.name}>{name}</h2>
      </div>
    </div>

    <div className={styles.row}>
      <div>
        <Trans i18nKey="subs:new_polls">
          {'Новые опросы'}
        </Trans>
      </div>
      <div>
        {newCount || t('no_polls')}
      </div>
    </div>

    <div className={styles.row}>
      <div>
        <Trans i18nKey="subs:current_polls">
          {'Текущие опросы'}
        </Trans>
      </div>
      <div>
        {activeCount || t('no_polls')}
      </div>
    </div>

    <div className={styles.chosen}>
      <div className={styles.chosenText}>
        {t('chosen_one')}
      </div>
      <PlainToggle
        className={styles.chosenBt}
        value={APP_POLLS}
        checked={isChosen}
        onChange={onSwitchChosen}
        prefix={isChosen ? t('on') : t('off')}
      />

      <div className={styles.chosenComment}>
        {t('will_be_displayed_in_top_menu')}
      </div>
    </div>

    <div className={styles.footer}>
      <div />
      <Button href={appLink}>
        <Trans i18nKey="subs:open_bt">
          {'Открыть'}
        </Trans>
        <IconBtnGo />
      </Button>
    </div>

  </div>
)

export default withTranslation('subs')(AppPolls)
